import { Box } from "@chakra-ui/react";
import { BaseStack, baseColors } from "goi_common/src/design-system";

/**
 * 필수 동의 고지 한 줄. 체크박스가 아니라 고지 + 약관 링크다.
 *
 * 동의는 제출 버튼을 누르는 행위로 갈음한다
 * (FileRequestModal, MubinsoLeadModal, CostNeedRetentionModal 동일).
 */
export function LeadConsentRow({ label, href }: { label: string; href: string }) {
  return (
    <BaseStack
      direction="horizontal"
      width="100%"
      justifyContent="space-between"
      alignItems="center"
      spacing={0}
    >
      <BaseStack direction="horizontal" alignItems="center" spacing={4}>
        <Box className="caption_2_m" color={baseColors.label_assistive_1}>
          필수
        </Box>
        <Box className="caption_2_m" color={baseColors.label_alternative_1}>
          {label}
        </Box>
      </BaseStack>
      <a
        className="caption_2_m"
        href={href}
        target="_blank"
        rel="noreferrer"
        style={{ color: baseColors.label_alternative_1 }}
      >
        보기
      </a>
    </BaseStack>
  );
}
